import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { BannerInterface } from "../../../@core/models/site-material-data.model";
import * as Sentry from "@sentry/browser";
import { DataService } from "../../../@core/services/data.service";
import { AnalyticsService } from "../../../@core/services/analytics.service";
import { Router } from "@angular/router";


@Component({
  selector: "app-material-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class MaterialBannerComponent implements OnInit {

  @Input() backgroundColor = 'grayBg';
  @Input() bannerSource = 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/970x250.png';
  @Input() bannerLink = '';
  data: BannerInterface;
  position: number = 0;
  activatePadding: boolean = false;
  moduleInfo: string;
  isStock: string = "";
  allElementAnimation: string;
  imageAnimation: string;
  loading: boolean = true;

  constructor(
    private dataService: DataService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "BannerComponent");
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.bannerLink = this.data.link;
    this.bannerSource = this.data.image;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.isStock = this.data.isStock;
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.imageAnimation = this.data.animation.image != '' ? this.data.animation.image : undefined;

    }
    this.loading = false;
  }

  clickExternalLink(link) {
    const currentSite = this.dataService.site$.getValue();
    if (currentSite) {
      this.analyticsService.trackConversion(currentSite, "click");
    }
    window.open(link, "_blank");
  }

  navigateTo(fragment: string) {
    if (fragment) {
      fragment = fragment.replace('/#', '')
      setTimeout(() => {
        this.router.navigate([''], { fragment: fragment })
        if (document.getElementById(fragment)) {
          document.getElementById(fragment).scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

}
